export default "__VITE_ASSET__d8f7783a__"